export default "__VITE_ASSET__xHLkC5QG__"